module.exports = __webpack_public_path__ + "static/media/model-sorento-xm12.2216b2da.webp";